<template>
  <myDialog :isDialog="isShowMbdr" title="模版导入" width="600px" @handleClose="$emit('handleClose')">
    <template slot="content">
      <myForm 
        ref="myFormRef" 
        labelWidth="90px" 
        :formData="formData" 
        :queryFn="queryAdd"
        @recombinationFormData="recombinationFormData"
        @successChange="successAddChange"
        >
        <template #mbDown>
          <a href="#"> xxx.xlsx</a>  
        </template>
        <template #drwj="scope">
          <div class="drwj">
            <el-input v-model="drwj" placeholder="请输入内容"></el-input>
            <el-upload action="#" :show-file-list="false">
              <div class="uploadBtn">上传</div>
            </el-upload>
          </div>
        </template>
        <template #ms>
          <span class="ms">默认从配置模版获取自动填充,可修改</span>
        </template>
      </myForm>
    </template>
    <template slot="footer">
      <div class="fillBtn" @click="$emit('handleClose')">
        <img src="@/assets/images/sys/drpz/save-icon.png" alt="">
        <span class="ml-1">保存</span>
      </div>
    </template>
  </myDialog>
</template>

<script>
export default {
  props: {
    isShowMbdr: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drwj:'',
      formData: [        
        {
          label: '模板下载',
          type: 'slot',
          key: 'mbDown'
        },
        {
          label: '导入文件',
          type: 'slot',
          key: 'drwj'
        },
        {
          label: '起始行',
          type: 'inputNumber',
          key: 'qsh',
          controlsPosition:'right',
          min:0,
        },
        {
          label: '',
          type: 'slot',
          key: 'ms'
        },
      ],
    };
  },
  mounted() {
    
  },
  methods: {
    // 新增接口
    queryAdd(e){
      //新增接口，编辑接口
      return (e)=>{e}
    },
    // 添加保存传参
    recombinationFormData(param,callback){
      callback({...param})
    },
    successAddChange(e,formModel){
     
    },
  },
};
</script>

<style lang="scss" scoped>
a{
  color: #0c7bf2;
  font-weight: 500;
  font-size: 14px;
  text-decoration-line: underline;
}
.drwj{
  display: flex;
  align-items: center;
  .uploadBtn{
    margin-left: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  
    width: 96px;
    height: 40px;
    border-radius: 3px;
    border: 1px solid #eaebed;
  
    color: #0c7bf2;
    font-weight: 500;
    font-size: 14px;
  }
}
.ms{
  color: #6b7885;
}
/deep/.el-dialog__body {
  padding: 32px 40px!important;
}
/deep/.el-input-number.is-controls-right .el-input__inner {
  text-align: left;
}
/deep/.el-input-number.is-controls-right .el-input-number__increase{
  border: none;
}
/deep/.el-input-number.is-controls-right .el-input-number__decrease{
  border: none;
}
/deep/.el-input-number__increase,/deep/.el-input-number__decrease{
  background: none;
}
/deep/.el-icon-arrow-up:before {
  content: "\e78f";
}
/deep/.el-icon-arrow-down:before {
  content: "\e790";
}
/deep/.el-input-number.is-controls-right .el-input-number__increase [class*=el-icon]{
  transform: scale(2);
  color: #0C7BF2;
}
/deep/.el-input-number.is-controls-right .el-input-number__decrease [class*=el-icon]{
  transform: scale(2);
  color: #0C7BF2;
}
</style>
